module.exports = __webpack_public_path__ + "img/MEDIA044.8d2ba47e.jpg";